import React from 'react'
import LoginDialogpage from './LoginDialogpage'

const Login = () => {
  return (
    <div>
    <LoginDialogpage/>

    </div>
  )
}

export default Login